import { render, staticRenderFns } from "./equipment.vue?vue&type=template&id=924d227e&scoped=true&"
import script from "./equipment.vue?vue&type=script&lang=js&"
export * from "./equipment.vue?vue&type=script&lang=js&"
import style0 from "./equipment.vue?vue&type=style&index=0&id=924d227e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924d227e",
  null
  
)

export default component.exports